import { useDebouncedCallback } from 'use-debounce';
import { useFormikContext } from 'formik';
import FormElement from 'components/global/FormElement';

interface ABLineAdjustmentOptionsProps {
  generatePreviewIfValid: (name: string, value?: string) => void;
}

const ABLineAdjustmentOptions = ({
  generatePreviewIfValid,
}: ABLineAdjustmentOptionsProps) => {
  const { setFieldValue } = useFormikContext();

  const handleChange = useDebouncedCallback(
    (name: string, event: { target: { value: string } }) => {
      const value = event.target.value.trim() || '0';
      setFieldValue(name, value);
      generatePreviewIfValid(name, value);
    },
    750,
  );

  return (
    <div>
      <h2>Adjust AB line (optional)</h2>
      <FormElement
        name="abline_rotation"
        label="Rotate AB line"
        direction="row"
        rightElement="°"
        onChangeCallback={(event) => handleChange('abline_rotation', event)}
      />
      <FormElement
        name="abline_adjust"
        label="Translate AB line"
        direction="row"
        rightElement="ft"
        onChangeCallback={(event) => handleChange('abline_adjust', event)}
      />
    </div>
  );
};

export default ABLineAdjustmentOptions;
